<app-layout preset="data">
  <app-layout-title>{{ 'SIDENAV.ROOT.couriers' | translate }}</app-layout-title>

  <app-layout-content>
    <div class="row search">
      <app-search #nameFilter field="name" [localeSearch]="true">
        {{ 'COMMON.search_by_name' | translate }}
      </app-search>
      <app-hint>
        <span>{{ 'ADMIN.assign_projects_hint' | translate }} <mat-icon color="primary">edit</mat-icon>
      </span>
    </app-hint>
  </div>

  <app-table [columns]="columns"
    [dataSource]="dataSource"
    [filter]="nameFilter"
    [reloader]="reloader"
    loadingType="all">

    <ng-container *app-table-header="'courier'">{{ 'COURIER_EXTENSIONS.TABLE.courier' | translate }}</ng-container>
    <ng-container *app-table-header="'projects'">{{ 'COURIER_EXTENSIONS.TABLE.projects' | translate }}</ng-container>
    <ng-container *app-table-header="'matchers'"><{{ 'COURIER_EXTENSIONS.TABLE.matchers' | translate }}</ng-container>

    <ng-container *app-table-column="let courier, name: 'courier'">
      {{courier.name}}
    </ng-container>

    <ng-container *app-table-column="let courier, name: 'projects'">
      <div class="assigned-projects">
        <app-scrollable-list [count]="courier.projects.length">
          <div class="project-list">
            @for (project of courier.projects; track project) {
              <app-project-view
                [iso]="project.isoCode"
                [name]="project.name"
                class="project">
              </app-project-view>
            }
          </div>
        </app-scrollable-list>

        <button (click)="openCourierEditor(courier)" mat-icon-button>
          <mat-icon color="primary">edit</mat-icon>
        </button>
      </div>
    </ng-container>

    <ng-container *app-table-column="let courier, name: 'matchers'">
      <a routerLink="/root/extensions/courier/{{courier.id}}/state-matchers"
        color="primary"
        mat-icon-button
        [matTooltip]="'ADMIN.open_matchers' | translate">
        <mat-icon>library_books</mat-icon>
      </a>
    </ng-container>
  </app-table>
</app-layout-content>
</app-layout>
